import { useEffect } from 'react';

interface UseOnIntervalOptions {
    leading: boolean;
    delay: number
}

export function useOnInterval(fn: () => any, { delay, leading = true } : UseOnIntervalOptions, deps: any[]) {
    return useEffect(() => {
        if (leading) {
            setTimeout(() => {
                fn.call(null);
            }, 10)
        }

        const handler = setInterval(() => {
            fn.call(null);
        }, delay);

        return () => {
            clearInterval(handler);
        };
    }, deps);
}
